import React, { useRef, useState, useCallback } from "react";
import "./style.css";
import Button from "../CtaButton";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
import ActionButton from "../ActionButton";
import { newCaseStudies } from "../../data/new-case-study-data";
import useIsMobile from "../../hooks/useIsMobile";
import { truncateWords } from "../../utils/textUtils";
import { Link } from "react-router-dom";

const NewCaseStudySection = ({ heading, description, shortHeading, cta, filter }) => {

  // SLIDER ARROWS
  const sliderRef = useRef();
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const isMobile = useIsMobile();

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  // SLIDER ARROWS

  const { t: caseStudiesCard } = useTranslation("caseStudiesPage");
  const caseStudiesContent = caseStudiesCard("caseStudies", {
    returnObjects: true,
  });

  const filteredCaseStudies = filter
    ? newCaseStudies.filter((item) => item.filterby === filter)
    : newCaseStudies;

  return (
    <>
      <section className="new-case-study-section position-relative">
        <div className="container">
          {/* Top Section */}
          <div className="row gap-3 gap-lg-0">
            <div className="col-lg-8">
              <h2 className="why-us-short-heading-text">{shortHeading}</h2>
              <p
                className="section-title"
                dangerouslySetInnerHTML={{ __html: heading }}
              ></p>
              <p className="section-subtitle" dangerouslySetInnerHTML={{ __html: description }}></p>
            </div>

            <div className="col-lg-4 justify-content-start flex-column align-items-lg-end d-flex align-items-start none-mobile-btn">
              <Button text={cta?.text || "Explore More Success Stories"} link="/case-studies" />

              <div className={`arrow-developing-slider mt-4`}>
                <img
                  onClick={handlePrev}
                  src="/images/arrow-right.png"
                  className={`left-image ${isBeginning ? "disabled" : ""}`}
                  alt="Arrow"
                  style={{ cursor: isBeginning ? "not-allowed" : "pointer" }}
                />
                <img
                  onClick={handleNext}
                  src="/images/arrow-right.png"
                  className={`right-arrow-image ${isEnd ? "disabled" : ""}`}
                  alt="Arrow"
                  style={{ cursor: isEnd ? "not-allowed" : "pointer" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container-0 mt-5">
          <Swiper
            slidesPerView={1}
            // centeredSlides={true}
            spaceBetween={0}
            navigation={false}
            // initialSlide={1}
            // autoplay={{
            //   delay: 5000,
            //   disableOnInteraction: false,
            //   pauseOnMouseEnter: true,
            // }}
            modules={[Navigation, Autoplay]}
            onSlideChange={handleSlideChange}
            className="mySwiper"
            ref={sliderRef}
            breakpoints={{
              320: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 10,
              },
              375: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 10,
              },
              780: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 15,
              },
              992: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 15,
              },
              1045: {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 0,
              },
            }}
          >
            {filteredCaseStudies?.map((card, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-md-12">
                        <div className="case-study-main-section">
                          <div className="case-study-image-box">
                            <img
                              src={`${card?.mainImage}`}
                              alt="Case Study Image"
                            />
                          </div>

                          <div className="case-card">
                            <h4 className="case-title">{card?.mainHeading}</h4>
                            <div className="meta-info mb-2">
                              <div>
                                <i class="fa-solid fa-industry"></i>
                                {/* <strong>Industry:</strong> {card?.tags?.industries?.map((item, index) => (<span key={index}>{item}</span>))} */}
                                <strong>Industry:</strong>{" "}
                                {card?.tags?.industries?.map((item, index) => (
                                  <Link to={`/industries/${item?.link}`}><span key={index}>
                                    {item.title}
                                    {index < card.tags.industries.length - 1 && ", "}
                                  </span>
                                  </Link>
                                ))}
                              </div>
                            </div>
                            <p className="case-description">
                              {/* {card?.mainDescription
                                ?.split(" ")
                                ?.slice(0, 10)
                                ?.join(" ")}{" "}
                              ... */}
                              {isMobile ? truncateWords(card?.mainDescription, 15) : card?.mainDescription?.split(" ")
                                ?.slice(0, 15)
                                ?.join(" ")}{" "}
                            </p>

                            <div className="case-studies-tag-wrapper">
                              {card?.tags?.services?.map((tag, index) => {
                                return (
                                  <Link to={tag?.link} key={index}>
                                    <span className="tag">
                                      {tag?.title}
                                    </span>
                                  </Link>
                                );
                              })}
                            </div>

                            <div className="case-studies-tag-wrapper">
                              {card?.tags?.serviceTags?.map((tag, index) => {
                                return (
                                  <Link to={tag?.link} key={index}>
                                    <span className="tag">
                                      {tag?.title}
                                    </span>
                                  </Link>
                                );
                              })}
                            </div>

                            {/* <ActionButton
                              styles={{ position: "absolute", bottom: "50px" }}
                              text={caseStudiesContent?.buttonText}
                              onClick={() => handleDownload(card?.pdfUrl)}
                            /> */}
                            <div className="mt-4">
                              <Button text={caseStudiesContent?.buttonText} link={`/case-studies/${card?.slug}`} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/* <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="new-blog-button">
                <Button text={cta?.text || "View All Case Studies"} link="/case-studies" />
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default NewCaseStudySection;
